import { AccountsReceivableSalesJournalReportRequestModel } from '../api/models/AccountsReceivableSalesJournalReportRequestModel';
import { AccountsReceivableSalesJournalReportFormModel } from '../models';

export const dataFormToRequest = (
  data: AccountsReceivableSalesJournalReportFormModel
): AccountsReceivableSalesJournalReportRequestModel => ({
  from: data.from,
  to: data.to,
  card_ids: data.card_ids?.map(card => card.id) || null,
  crs_number: data.crs_number ?? null,
  invoice_types: data.invoice_types || null,
  currency_id: data.currency?.id || null,
  currency_application: data.currency_application || null,
  fixed_at: data.fixed_at || null,
  order_by: data.order_by || null,
  sens: data.sens || null,
  file_type: data?.file_type,
});
